































































import Vue, {PropType} from 'vue';
import {SubmissionDef} from '@/types/Submission';
import FavoriteStar from './FavoriteStar.vue';

export default Vue.extend({
    name: 'submission-item',

    components: { FavoriteStar },

    props: {
        submission: {
            type: Object as PropType<SubmissionDef>,
            required: true,
        },
        favorite: {
            type: Boolean as PropType<boolean>,
            required: false,
        },
    },
});
